import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { glassCardClass } from "@/recruitment/styles.js";
import { supabase } from "@/lib/supabase";

const MAIN_APP_LOGIN_URL = import.meta.env.VITE_MAIN_APP_LOGIN_URL || "https://kconnect.pl/login";

function redirectToSso(nextPath) {
  const targetUrl = `${window.location.origin}${nextPath}`;
  try {
    const loginUrl = new URL(MAIN_APP_LOGIN_URL, window.location.origin);
    loginUrl.searchParams.set("next", targetUrl);
    window.location.href = loginUrl.toString();
    return;
  } catch (_) {
    const fallback = new URL("https://kconnect.pl/login");
    fallback.searchParams.set("next", targetUrl);
    window.location.href = fallback.toString();
  }
}

export default function RecruitmentHomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectLoggedUser = async () => {
      const {
        data: { user },
        error: authError,
      } = await supabase.auth.getUser();

      if (authError || !user) return;

      const { data: appUser, error: appUserError } = await supabase
        .from("app_users")
        .select("roles")
        .eq("id", user.id)
        .maybeSingle();

      if (appUserError) {
        toast.error(appUserError.message || "Nie udało się ustalić roli użytkownika.");
        return;
      }

      const roles = appUser?.roles || [];
      const isAdmin = roles.includes("branch_admin") || roles.includes("super_admin");

      if (isAdmin) {
        navigate("/admin", { replace: true });
        return;
      }

      navigate("/parent", { replace: true });
    };

    redirectLoggedUser();
  }, [navigate]);

  return (
    <div className="mx-auto grid max-w-3xl gap-6">
      <Card className={glassCardClass}>
        <CardHeader>
          <CardTitle>Witaj w module rekrutacji</CardTitle>
          <CardDescription>Wybierz swój typ dostępu, aby przejść do odpowiedniego procesu.</CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4 md:grid-cols-2">
          <Button asChild size="lg" className="justify-between">
            <Link to="/parent/entry">
              Jestem rodzicem
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
          <Button size="lg" variant="outline" className="justify-between" onClick={() => redirectToSso("/admin")}>
            Jestem administratorem
            <ArrowRight className="h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
